import { useState } from 'react';
import {
	Menu,
	MenuItem,
	Button,
	FormControlLabel,
	Switch,
	TextField,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Box,
} from '@mui/material';
import { TBoxesStructureItem, emBoxesStructure } from '../emBoxesStructure';

interface EmSettingsDialogProps {
	open: boolean;
	onClose: () => void;
	anchorEl: HTMLElement | null;
	boxesStructure: TBoxesStructureItem[];
	onSave: (newStructure: TBoxesStructureItem[]) => void;
}

export const EmSettingsDialog = ({
	open,
	onClose,
	anchorEl,
	boxesStructure,
	onSave,
}: EmSettingsDialogProps) => {
	const [autoLayout, setAutoLayout] = useState(false);

	const handleSave = () => {
		onSave(boxesStructure);
		onClose();
	};

	const handleToggleShow = (boxIndex: number) => {
		const newStructure = [...boxesStructure];
		newStructure[boxIndex].show = !newStructure[boxIndex].show;
		onSave(newStructure);
	};

	const handleWidthChange = (boxIndex: number, value: number) => {
		const newStructure = [...boxesStructure];
		newStructure[boxIndex].width = value;
		onSave(newStructure);
	};

	const handleCheckAll = () => {
		onSave(boxesStructure.map((box) => ({ ...box, show: true })));
	};

	const handleUncheckAll = () => {
		onSave(boxesStructure.map((box) => ({ ...box, show: false })));
	};

	const handleSetDefault = () => {
		const defaultById = new Map(emBoxesStructure().map((box) => [box.id, box]));
		onSave(
			boxesStructure.map((box) => {
				const defaultBox = defaultById.get(box.id);
				return defaultBox ? { ...box, show: defaultBox.show, width: defaultBox.width } : box;
			}),
		);
	};

	return (
		<Menu
			open={open}
			onClose={onClose}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					gap: 1,
					px: 1.5,
					pt: 1,
					pb: 0.5,
				}}
			>
				<Button size="small" onClick={handleCheckAll}>
					Check all
				</Button>
				<Button size="small" onClick={handleUncheckAll}>
					Uncheck all
				</Button>
				<Button size="small" onClick={handleSetDefault}>
					Set default
				</Button>
			</Box>
			<Table size="small">
				<TableBody>
					{boxesStructure.map((box, boxIndex) => (
						<TableRow key={box.id}>
							<TableCell component="th" scope="row" sx={{ p: '4px 8px', border: 0 }}>
								{box.label}
							</TableCell>
							<TableCell align="center" sx={{ p: '0px 0px 0px 8px', border: 0 }}>
								<FormControlLabel
									control={
										<Switch
											checked={box.show}
											onChange={() => handleToggleShow(boxIndex)}
											size="small"
											sx={{
												'& .MuiSwitch-thumb': {
													width: '14px',
													height: '14px',
												},
											}}
										/>
									}
									label=""
								/>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
			{/* </TableContainer> */}
		</Menu>
	);
};
